import { StylesClasses, commonStyles, createStyles } from '@utils/styles'

const styles = createStyles({
  card: {
    display: 'flex',
    flexDirection: {
      xs: 'column',
      md: 'row',
    },
    alignItems: 'stretch',
    gap: { xs: '16px', md: '24px' },
    width: '100%',
    height: '100%',
    minHeight: 'unset',
    padding: { xs: '16px', md: '20px' },
    borderRadius: '16px',
    border: '1px solid',
    borderColor: 'border.light',
    backgroundColor: 'background.paper',
    boxShadow: 'none',
    textDecoration: 'none',
    color: 'inherit',
    boxSizing: 'border-box',
    '&:hover': {
      boxShadow: '0px 8px 28px rgba(0, 0, 0, 0.12)',
      '& .search-service-cta': {
        textDecoration: 'underline',
      },
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    gap: '12px',
    flex: 1,
    minWidth: 0,
  },
  copy: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  title: {
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
    textOverflow: 'ellipsis',
  },
  description: {
    ...commonStyles.getLineClampStyles(2, 48),
    height: { xs: '38px', md: '48px' },
  },
  cta: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    width: 'fit-content',
    marginTop: '4px',
  },
  media: {
    flexShrink: 0,
    width: {
      xs: '100%',
      md: '42%',
    },
    minHeight: { xs: '160px', md: '168px' },
    borderRadius: '12px',
    backgroundColor: '#F0EEFF',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
    img: {
      objectFit: 'cover',
    },
  },
  image: {
    display: { xs: 'none', md: 'flex' },
    borderRadius: '12px',
    width: {
      xs: '100%',
      md: '50%',
    },
    height: { xs: '140px', md: '150px' },
    '& img': {
      objectFit: 'contain',
    },
  },
})

export type StylesClassNames = StylesClasses<typeof styles>

export default styles
